import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
  createContext,
  useReducer,
  useCallback,
  memo,
} from 'react'
import { Table as MuiTable, TableContainer, Paper } from '@mui/material'
// import moment from 'moment';
import { isArray, isEqual } from 'lodash'
import TableToolbar from '../TableToolbar'
import TableHead from '../TableHead'
import TableBody from '../TableBody'
import Pagination from '../Pagination'

export const TableContext = createContext()

const ehData = (valor) => {
  // TODO usar luxon
  // const retorno = (format) => moment(valor, format).format('YYYYMMDDHHmmss');
  // if (/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/.test(valor)) return retorno('DD/MM/YYYY');
  // if (/\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}/.test(valor)) return retorno('DD/MM/YYYY HH:mm');
  // if (/\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}/.test(valor)) return retorno('DD/MM/YYYY HH:mm:ss');
  // if (/\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(.\d)*/.test(valor)) return retorno('YYYY-MM-DD HH:mm:ss');
  return valor
}

function descendingComparator(a, b, orderBy) {
  const aO = ehData(a[orderBy])
  const bO = ehData(b[orderBy])
  if (bO < aO) return -1
  if (bO > aO) return 1
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator, line) {
  const stabilizedThis = array.map((el, index) => [el, line(el), index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[1], b[1])
    if (order !== 0) return order
    return a[2] - b[2]
  })
  return stabilizedThis.map((el) => el[0])
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'setSelected':
      return {
        ...state,
        selected: action.value,
      }
    case 'setPage':
      return {
        ...state,
        page: action.value,
      }
    case 'decremmentPage':
      return {
        ...state,
        page: state.page === 0 ? 0 : state.page - 1,
      }
    case 'setRowsPerPage':
      return {
        ...state,
        rowsPerPage: action.value,
      }
    case 'setOrder':
      return {
        ...state,
        order: action.value,
      }
    case 'setOrderBy':
      return {
        ...state,
        orderBy: action.value,
      }
    case 'setFilter':
      return {
        ...state,
        filter: action.value,
      }
    case 'setOpen':
      return {
        ...state,
        open: action.value,
      }
    case 'setLoading':
      return {
        ...state,
        loading: action.value,
      }
    case 'mount':
      if (!action.value) return state
      return action.value
    default:
      return state
  }
}

const initialState = (defaultRowsPerPage) => ({
  selected: [],
  page: 0,
  rowsPerPage: defaultRowsPerPage,
  order: 'asc',
  orderBy: -1,
  filter: '',
  open: undefined,
  loading: false,
})

// eslint-disable-next-line react/display-name
const Table = forwardRef(
  (
    {
      ToolbarComponent = TableToolbar,
      HeadComponent = TableHead,
      BodyComponent = TableBody,
      PaginationComponent = Pagination,
      FooterComponent = undefined,
      footerProps,
      dados,
      head = [],
      line = (i) => i,
      actions,
      title,
      defaultRowsPerPage = 10,
      rowsPerPageOptions = [10, 25, 50],
      enableCheck,
      disableCheckIf,
      showCount,
      lineStyle,
      lineClass = () => undefined,
      onClick,
      children = undefined,
      style,
      className,
      columnStyles,
      headerColumnStyles,
      columnOptions,
      disableFilter,
      filterLabel = 'Filtro',
      indexToSelect = 0,
      disableSorting = [],
      size = 'small',
      onOpen,
      lineTitle,
      onClose,
      fixedToolbar,
      onSelect,
      customKey,
      columnProps = () => '',
      savedState = {},
    },
    ref,
  ) => {
    const [state, dispatch] = useReducer(
      reducer,
      initialState(defaultRowsPerPage),
    )
    const memoState = useMemo(() => ({ ...state, dispatch }), [state, dispatch])
    const { selected, page, rowsPerPage, order, orderBy, filter, open } =
      memoState

    const [lista, setLista] = useState(
      dados /* .map(linha => isArray(linha) ? linha : Object.values(linha)) */ ||
        [],
    )
    const [ctrlPgn, setCtrlPgn] = useState({
      qtRegs: defaultRowsPerPage,
      pgAtl: 1,
    })
    const { ordCols } = ctrlPgn

    useEffect(() => {
      dispatch({ type: 'mount', value: savedState.current })
    }, [savedState])

    useEffect(() => {
      return () => (savedState.current = state)
    }, [savedState, state])

    useEffect(() => {
      if (isArray(dados))
        setLista(
          dados /* .map(linha => isArray(linha) ? linha : Object.values(linha)) */ ||
            [],
        )
    }, [dados])

    // const retornaAcao = useCallback((pgAtl, page) => {
    //   if (page === pgAtl) return undefined;
    //   else if (page === pgAtl + 1) return 'N';
    //   else if (page === pgAtl - 1) return 'P';
    //   else if (page === ctrlPgn.recordCount) return 'L';
    //   else if (page === 0) return 'F';
    //   return `S=${page}`;
    // }, [ctrlPgn.recordCount]);

    useEffect(() => {
      if (
        isArray(lista) &&
        lista.length > 0 &&
        page === Math.ceil(lista.length / parseInt(rowsPerPage, 10))
      )
        dispatch({ type: 'decremmentPage' })
    }, [page, lista.length, rowsPerPage, ctrlPgn.recordCount, lista])

    useEffect(() => dispatch({ type: 'setSelected', value: [] }), [lista])

    useEffect(() => {
      if (onSelect) onSelect(selected)
    }, [onSelect, selected])

    useImperativeHandle(ref, () => ({
      setOpen: (index) => handleOpenClose(index),
      getOpen: dadosMostrados[open],
      getSelected: selected,
      setLoading: (value) => dispatch({ type: 'setLoading', value }),
    }))

    const dadosNaoCortados = useMemo(() => {
      if (isArray(lista) && lista.length > 0)
        return (
          stableSort(lista, getComparator(order, orderBy), line).filter(
            (linha) =>
              isArray(line(linha))
                ? line(linha).filter((item) =>
                    filter
                      ? new RegExp(`.*${filter}.*`, 'gi').test(item?.toString())
                      : true,
                  ).length > 0
                : true,
          ) || []
        )
      return []
    }, [lista, filter, order, orderBy, line])

    const cortaDados = useCallback(
      (dados) =>
        dados?.slice(
          defaultRowsPerPage === 0 ? undefined : page * rowsPerPage,
          defaultRowsPerPage === 0
            ? undefined
            : page * rowsPerPage + rowsPerPage,
        ),
      [page, rowsPerPage, defaultRowsPerPage],
    )

    const dadosMostrados = useMemo(() => {
      return cortaDados(dadosNaoCortados) || []
    }, [dadosNaoCortados, cortaDados])

    const handleOpenClose = useCallback(
      (index) => {
        if (index === open || (!index && index !== 0)) {
          dispatch({ type: 'setOpen', value: undefined })
          if (onClose && (index || open))
            onClose({
              linhaOriginal: dadosMostrados[index || open],
              linhaFormatada: line(dadosMostrados[index || open]),
            })
        } else {
          dispatch({ type: 'setOpen', value: index })
          if (onOpen)
            onOpen({
              linhaOriginal: dadosMostrados[index],
              linhaFormatada: line(dadosMostrados[index]),
            })
        }
      },
      [open, onClose, onOpen, dadosMostrados, dispatch, line],
    )

    return (
      <TableContext.Provider
        value={{ ...memoState, dadosMostrados, lista, indexToSelect }}
      >
        <TableContainer
          component={Paper}
          variant="outlined"
          {...{ style, className }}
        >
          <ToolbarComponent
            numSelected={selected.length}
            disableFilter={disableFilter}
            {...{
              actions,
              title,
              selected,
              filter,
              filterLabel,
              lista,
              indexToSelect,
              fixedToolbar,
            }}
          />
          <MuiTable {...{ size }}>
            <HeadComponent
              size={dadosNaoCortados.length}
              numSelected={selected.length}
              rowCount={
                rowsPerPage > dadosNaoCortados.length
                  ? dadosNaoCortados.length
                  : rowsPerPage
              }
              {...{
                head,
                order,
                orderBy,
                enableCheck,
                headerColumnStyles,
                disableSorting,
                ordCols,
                cortaDados,
                disableCheckIf,
                line,
              }}
            />
            <BodyComponent
              {...{
                children,
                line,
                lineStyle,
                lineTitle,
                handleOpenClose,
                lineClass,
                enableCheck,
                columnStyles,
                head,
                columnOptions,
                columnProps,
                onClick,
                indexToSelect,
                open,
                dadosMostrados,
                customKey,
                disableCheckIf,
              }}
            />
            {FooterComponent && <FooterComponent {...footerProps} />}
          </MuiTable>
          {rowsPerPageOptions !== 0 &&
            Math.ceil(
              dadosNaoCortados.length / parseInt(rowsPerPageOptions[0], 10),
            ) > 1 && (
              <PaginationComponent
                count={dadosNaoCortados.length}
                onChangePage={(_, value) => {
                  dispatch({ type: 'setPage', value })
                  setCtrlPgn({ ...ctrlPgn, pgAtl: value + 1 })
                }}
                onChangeRowsPerPage={(e) => {
                  dispatch({
                    type: 'setRowsPerPage',
                    value: parseInt(e.target.value, 10),
                  })
                  dispatch({ type: 'setPage', value: 0 })
                  setCtrlPgn({
                    ...ctrlPgn,
                    pgAtl: 1,
                    qtRegs: parseInt(e.target.value, 10),
                  })
                }}
                {...{ showCount, page, rowsPerPageOptions, rowsPerPage }}
              />
            )}
        </TableContainer>
      </TableContext.Provider>
    )
  },
)

export default memo(Table, isEqual)
